import { ApplicationForm } from '../../components/ApplicationForm'
import FormlessJourneyV4Wrapper from '../../components/ApplicationForm/FormlessJourney/FormelssJourneyV4/FormlessJourneyV4Wrapper'
import FormlessJourney from '../../components/ApplicationForm/FormlessJourney/FormlessJourney'
import FormlessJourneyV3Wrapper from '../../components/ApplicationForm/FormlessJourney/WithInterstitialAndLandingPage/FormlessJourneyV3Wrapper'
import { PrefillReviewPageApplicationForm } from '../../components/ApplicationForm/PrefillReviewPageApplicationForm'
import { PrefillReviewPageApplicationFormProvider } from '../../components/ApplicationForm/PrefillReviewPageApplicationFormContext'
import { RequiredDetailsPageApplicationForm } from '../../components/ApplicationForm/RequiredDetails/RequiredDetailsPageApplicationForm'
import FormlessJourneyWithContinueCtaWrapper from '../../components/ApplicationForm/FormlessJourney/WithContinueCta/FormlessJourneyWithContinueCTAWrapper'
import Source from '../../types/Source'
import { FeatureSwitches, LenderDetails, ApplicationFormAnswers } from '../../components/ApplicationForm/ApplicationFormContext'
import { AttributionDetails } from '../../components/ApplicationForm/types'
import { Application } from '../../Mappers/ApplicationFormMapper'
import QuestionKey from '../../Questions/question-key'
import { AppFormEventParams } from '../../services/events-service'
import { VehicleDetailsDataObject } from '../../services/vehicle-service'
import { AttributionContext } from '../../context'
import { SubmissionResponse } from '../../types/Formless'
import { WafBotLabels } from '../getServerSideProps/getWafBotLabels'

type RenderApplicationFormProps = {
  featureSwitches: FeatureSwitches
  experimentName: string
  attribution: AttributionDetails
  submissionResponse?: SubmissionResponse
  lenderDetails?: LenderDetails
  mappedApplication?: Application
  eventsServiceUrl: string
  appFormEventParams?: AppFormEventParams
  questionConfig: QuestionKey[]
  prefillData?: ApplicationFormAnswers
  vehicle?: VehicleDetailsDataObject
  source?: Source
  showRepRate?: boolean
  customerId: string
  isBotTraffic: boolean
  wafBotLabels?: WafBotLabels
  isOfficeTraffic: boolean
  journey: string
}

const renderApplicationFormForJourney = ({
  experimentName,
  attribution,
  submissionResponse,
  lenderDetails,
  mappedApplication,
  questionConfig,
  eventsServiceUrl,
  appFormEventParams,
  prefillData,
  customerId,
  isBotTraffic,
  wafBotLabels,
  isOfficeTraffic,
  journey,
  featureSwitches,
  vehicle,
  source,
  showRepRate
}: RenderApplicationFormProps) => {
  const isEligibleForFormlessJourneyWithContinueCta = attribution.source === 'carmoola' || attribution.source === 'experian'
  
  const {
    formlessJourneyV1,
    formlessJourneyV3,
    formlessJourneyV4,
    requiredDetailsV1,
    reviewPageV3
  } = featureSwitches

  if (formlessJourneyV4) {
    return (
      <FormlessJourneyV4Wrapper
        experimentName={experimentName}
        attribution={attribution}
        submissionResponse={submissionResponse}
        isPreapproved={lenderDetails?.preapproved ?? false}
        mappedApplication={mappedApplication}
        lenderDetails={lenderDetails}
        eventsServiceUrl={eventsServiceUrl}
        appFormEventParams={appFormEventParams}
      />
    )
  }

  if (formlessJourneyV3) {
    return (
      <FormlessJourneyV3Wrapper
        experimentName={experimentName}
        attribution={attribution}
        submissionResponse={submissionResponse}
        isPreapproved={lenderDetails?.preapproved ?? false}
        eventsServiceUrl={eventsServiceUrl}
        appFormEventParams={appFormEventParams}
        mappedApplication={mappedApplication}
        lenderDetails={lenderDetails}
      />
    )
  }
        
  if (formlessJourneyV1) { 
    if (isEligibleForFormlessJourneyWithContinueCta) {
      return (
        <FormlessJourneyWithContinueCtaWrapper
          experimentName={experimentName}
          attribution={attribution}
          submissionResponse={submissionResponse}
          isPreapproved={lenderDetails?.preapproved ?? false}
          eventsServiceUrl={eventsServiceUrl}
          appFormEventParams={appFormEventParams}
          mappedApplication={mappedApplication}
          lenderDetails={lenderDetails}
        />
      )
    }

    return (
      <FormlessJourney
        experimentName={experimentName}
        attribution={attribution}
        submissionResponse={submissionResponse}
        isPreapproved={lenderDetails?.preapproved ?? false}
        eventsServiceUrl={eventsServiceUrl}
        appFormEventParams={appFormEventParams}
        mappedApplication={mappedApplication}
      />
    )
  }

  if (requiredDetailsV1) {
    return (
      <RequiredDetailsPageApplicationForm
        config={questionConfig}
        vehicle={prefillData?.vehicleDetails}
        prefillData={prefillData}
        lenderDetails={lenderDetails}
        eventsServiceUrl={eventsServiceUrl}
        customerId={customerId}
        experimentName={experimentName}
        isBotTraffic={isBotTraffic}
        wafBotLabels={wafBotLabels}
        isOfficeTraffic={isOfficeTraffic}
        journey={journey}
        featureSwitches={featureSwitches}
        attribution={attribution}
      />
    )
  }


  if (reviewPageV3) {
    return (
      <PrefillReviewPageApplicationFormProvider>
        <PrefillReviewPageApplicationForm
          config={questionConfig}
          vehicle={prefillData?.vehicleDetails}
          prefillData={prefillData}
          lenderDetails={lenderDetails}
          eventsServiceUrl={eventsServiceUrl}
          customerId={customerId}
          experimentName={experimentName}
          isBotTraffic={isBotTraffic}
          wafBotLabels={wafBotLabels}
          isOfficeTraffic={isOfficeTraffic}
          journey={journey}
          featureSwitches={featureSwitches}
          attribution={attribution}
        />
      </PrefillReviewPageApplicationFormProvider>
    )
  }

  return (
    <ApplicationForm
      config={questionConfig}
      vehicle={vehicle}
      source={source}
      prefillData={prefillData}
      lenderDetails={lenderDetails}
      showRepRate={showRepRate}
      eventsServiceUrl={eventsServiceUrl}
      customerId={customerId}
      experimentName={experimentName}
      isBotTraffic={isBotTraffic}
      wafBotLabels={wafBotLabels}
      isOfficeTraffic={isOfficeTraffic}
      journey={journey}
      featureSwitches={featureSwitches}
    />
  )
}

export const renderApplicationForm = (props: RenderApplicationFormProps) => {
  const { attribution } = props
  return <AttributionContext.Provider value={attribution}>{renderApplicationFormForJourney(props)}</AttributionContext.Provider>
}
